import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({

  enrollmentSummaryTitle: {
    id: 'instruct.courseInfo.enrollmentSummary.title',
    defaultMessage: 'Course Enrollment',
    description: 'Title for the enrollment summary section',
  },
  allEnrollmentsLabel: {
    id: 'instruct.courseInfo.enrollmentSummary.allEnrollments',
    defaultMessage: 'All Enrollments',
    description: 'Label for all enrollments count',
  },
  staffAndAdminsLabel: {
    id: 'instruct.courseInfo.enrollmentSummary.staffAndAdmins',
    defaultMessage: 'Staff / Admin',
    description: 'Label for staff and admins count',
  },
  learnersLabel: {
    id: 'instruct.courseInfo.enrollmentSummary.learners',
    defaultMessage: 'Learners',
    description: 'Label for learners count',
  },
  verified: {
    id: 'instruct.courseInfo.enrollmentSummary.verified',
    defaultMessage: 'Verified',
    description: 'Label for verified enrollments count',
  },
  audit: {
    id: 'instruct.courseInfo.enrollmentSummary.audit',
    defaultMessage: 'Audit',
    description: 'Label for audit enrollments count',
  },
  masters: {
    id: 'instruct.courseInfo.enrollmentSummary.masters',
    defaultMessage: 'Master\'s',
    description: 'Label for master\'s enrollments count',
  },
  honor: {
    id: 'instruct.courseInfo.enrollmentSummary.honor',
    defaultMessage: 'Honor',
    description: 'Label for honor enrollments count',
  },
  professional: {
    id: 'instruct.courseInfo.enrollmentSummary.professional',
    defaultMessage: 'Professional',
    description: 'Label for professional enrollments count',
  },
  noIdProfessional: {
    id: 'instruct.courseInfo.enrollmentSummary.noIdProfessional',
    defaultMessage: 'No ID Professional',
    description: 'Label for no ID professional enrollments count',
  },
  credit: {
    id: 'instruct.courseInfo.enrollmentSummary.credit',
    defaultMessage: 'Credit',
    description: 'Label for credit enrollments count',
  },
  paidBootcamp: {
    id: 'instruct.courseInfo.enrollmentSummary.paidBootcamp',
    defaultMessage: 'Paid Bootcamp',
    description: 'Label for paid bootcamp enrollments count',
  },
  unpaidBootcamp: {
    id: 'instruct.courseInfo.enrollmentSummary.unpaidBootcamp',
    defaultMessage: 'Unpaid Bootcamp',
    description: 'Label for unpaid bootcamp enrollments count',
  },
  executiveEducation: {
    id: 'instruct.courseInfo.enrollmentSummary.executiveEducation',
    defaultMessage: 'Executive Education',
    description: 'Label for executive education enrollments count',
  },
  paidExecutiveEducation: {
    id: 'instruct.courseInfo.enrollmentSummary.paidExecutiveEducation',
    defaultMessage: 'Paid Executive Education',
    description: 'Label for paid executive education enrollments count',
  },
  unpaidExecutiveEducation: {
    id: 'instruct.courseInfo.enrollmentSummary.unpaidExecutiveEducation',
    defaultMessage: 'Unpaid Executive Education',
    description: 'Label for unpaid executive education enrollments count',
  },
});

export default messages;
